import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

/**
 * DragAndDropList
 * @param {Array} items - Array of items to display and reorder
 * @param {Function} setItems - Setter for the items array
 * @param {Function} renderItem - Function to render each item (item, index) => ReactNode
 * @param {string} droppableId - Unique id for the droppable area
 */
const DragAndDropList = ({ items, setItems, renderItem, droppableId }) => {
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(items);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setItems(reordered);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items && items.length > 0
              ? items.map((item, index) => (
                  <Draggable key={String(item.id || item)} draggableId={String(item.id || item)} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={{
                          userSelect: 'none',
                          ...provided.draggableProps.style,
                          background: snapshot.isDragging ? '#e9ecef' : 'white',
                          marginBottom: 8,
                          borderRadius: 4,
                          boxShadow: snapshot.isDragging ? '0 2px 8px rgba(0,0,0,0.1)' : 'none',
                          display: 'flex',
                          alignItems: 'center',
                          pointerEvents: 'auto',
                        }}
                        tabIndex={0}
                        aria-label={`Drag to reorder question ${index + 1}`}
                      >
                        <span
                          {...provided.dragHandleProps}
                          style={{
                            cursor: 'grab',
                            display: 'inline-block',
                            marginRight: 8,
                            fontWeight: 'bold',
                            fontSize: 18,
                            color: '#333',
                            userSelect: 'none',
                          }}
                          aria-label="Drag handle"
                          tabIndex={-1}
                        >
                          ≡
                        </span>
                        {renderItem(item, index)}
                      </div>
                    )}
                  </Draggable>
                ))
              : null}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DragAndDropList;
